<template>
  <div class="wrapper">
    <div class="box form">
      <h2 class="title">Create account at Evrland</h2>
      <section class="fields">
        <b-field label="Email">
          <b-input type="email" v-model="email" autofocus></b-input>
        </b-field>
        <b-field label="Password" message="at least 8 symbols long">
          <b-input type="password" v-model="password" password-reveal></b-input>
        </b-field>
        <b-field label="Confirm password">
          <b-input type="password" v-model="passwordConfirmation" password-reveal></b-input>
        </b-field>
        <b-checkbox v-model="acceptedTerms">I agree with <router-link to="/terms">Terms Of Use And Service</router-link></b-checkbox>
      </section>
      <button @click="signUp" class="button is-success is-medium" :disabled="!formIsValid">
        <span>Sign up</span>
      </button>
    </div>
    <section class="bottom-links">
      <router-link to="signin">Sign in instead</router-link>
    </section>
  </div>
</template>

<script>
import http from '../../utils/http';
import { isEmailValid } from '../../utils/misc';
import BCheckbox from 'buefy/src/components/checkbox/Checkbox';

export default {
  name: 'sign-up',
  components: { BCheckbox },
  data: () => ({
    email: '',
    password: '',
    passwordConfirmation: '',
    acceptedTerms: false,
  }),
  methods: {
    errorSnackbar(text) {
      this.$snackbar.open({
        message: text,
        type: 'is-warning',
        position: 'is-top',
        actionText: 'Ok',
      });
    },
    successSnackbar() {
      this.$snackbar.open({
        message: 'Account was created successfuly. Please confirm your email',
        type: 'is-success',
        position: 'is-top',
        actionText: 'Ok',
      });
    },
    signUp() {
      http.post(
        '/auth/register',
        {
          email: this.email,
          password: this.password,
          passwordConfirmation: this.passwordConfirmation,
        },
      ).then(() => {
        this.successSnackbar();
        this.$router.push('/');
      }).catch((err) => {
        if (err.response.data.error === 'email is taken') {
          this.errorSnackbar('This email is taken');
          this.email = '';
        } else if (err.response.data.error === 'passwords don\'t match') {
          this.errorSnackbar('Passwords don\'t match');
          this.password = '';
          this.passwordConfirmation = '';
        } else {
          this.errorSnackbar('Unknown error! Please try again later');
        }
      });
    },
    isEmailValid,
  },
  computed: {
    emailIsValid() {
      return this.isEmailValid(this.email);
    },
    formIsValid() {
      return this.acceptedTerms
        && this.isEmailValid(this.email)
        && this.password !== ''
        && this.password.length >= 8
        && this.password === this.passwordConfirmation;
    },
  },
};
</script>


<style scoped>

.wrapper {
  width: 100%;
  height: 90vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.fields {
  margin-bottom: 30px;
}

.form {
  margin-bottom: 20px;
}

.bottom-links a {
  color: white;
  font-size: 18px;
}

</style>
